<div fxLayout="column" fxLayoutGap="20px">
  <h1>Provas do Concurso:</h1>
  <h2>{{ concursoTitulo }}</h2>
  <div fxLayout="row" fxLayoutAlign="end">
    <a mat-flat-button color="primary" [routerLink]="['acompanhamento-correcao']">
      <mat-icon>visibility</mat-icon> Acompanhar Correção
    </a>
  </div>


  <mat-form-field appearance="outline">
    <mat-label>{{ addProvaLabel }}</mat-label>
    <mat-select [formControl]="adicionarProvaFC" data-seletor="adicionar">
      <mat-option *ngFor="let enum of tipoProva | keyvalue" [value]="enum.key">
        {{ enum.value }}
      </mat-option>
    </mat-select>
    <mat-icon matSuffix class="icon-muted">note_add</mat-icon>
  </mat-form-field>

  <div fxLayout="row" fxLayoutGap="20px">
    
    <div fxFlex="40%" class="fase-quadros">
      <div class="table-title">Primeira Fase</div>
      <div *ngFor="let row of provasPrimeiraFase; let i = index">
        <mat-card class="exam-card" [ngClass]="{ 'order-alert': row.provaOrdem == null }">
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div fxFlex="auto">
              <b>{{ row.provaOrdem }}ª</b>: {{ tipoProvaStr(row.tipoProva) }}
            </div>
        
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <span>Peso:</span>
              <input matInput fxFlex="0 1 50px" type="number" min="0" [(ngModel)]="row.provaPeso" 
                     (focus)="valorAnteriorPeso = row.provaPeso"
                     (blur)="atualizarPeso(row, row.provaPeso)"
                     (keyup.enter)="atualizarPeso(row, row.provaPeso)"
                     class="w-50" />
            </div>
        
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
              <button mat-icon-button (click)="atualizarOrdem(row, (row.provaOrdem ?? 0) - 1)" matTooltip="Subir" [disabled]="i === 0">
                <mat-icon class="small-icon">arrow_upward</mat-icon>
              </button>
              <button mat-icon-button (click)="atualizarOrdem(row, (row.provaOrdem ?? 0) + 1)" matTooltip="Descer" [disabled]="i === provasPrimeiraFase.length - 1">
                <mat-icon class="small-icon">arrow_downward</mat-icon>
              </button>
              <button mat-icon-button (click)="atualizarFase(row, ProvaFase.FASE2)" matTooltip="Mover para Segunda Fase">
                <mat-icon class="small-icon">arrow_forward</mat-icon>
              </button>
              <button mat-icon-button (click)="excluir(row)" matTooltip="Excluir" [disabled]="row.temNotas">
                <mat-icon class="small-icon">close</mat-icon>
              </button>
            </div>
          </div>
        
          <div *ngIf="row.provaOrdem === 1" fxLayout="column" fxLayoutGap="5px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <span>Início das correções:</span>
              <input matInput type="date"
                class="w-150"
                [value]="row.dataInicio"
                (focus)="valorAnteriorDataInicial = row.dataInicio"
                (change)="atualizarDataInicial(row, $event)" />
            </div>
            <div *ngIf="deveExibirDataInicioDocumentos(row)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <span>Início da visualização dos documentos:</span>
              <input matInput type="date"
                class="w-150"
                [value]="row.dataInicioDocumentos"
                (focus)="valorAnteriorDataInicioDocumentos = row.dataInicioDocumentos"
                (change)="atualizarDataInicioDocumentos(row, $event)" />
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    
    <div fxFlex="20%" class="fase-quadros">
      <div class="table-title">
        <div>Distribuir provas nas fases</div>
        <div class="badge">
          <mat-icon *ngIf="provasSemFase.length > 0"
            matBadge="{{ provasSemFase.length }}" 
            matBadgeColor="warn"
            matBadgePosition="before"
            matBadgeSize="medium"
            fxFlexAlign="end"
            matTooltip="Ainda faltam provas para serem distribuídas">assignment
          </mat-icon>
        </div>
      </div>
      <div *ngFor="let row of provasSemFase">
        <mat-card class="exam-card">
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">                    
            <div>
              <button mat-mini-fab color="primary" (click)="atualizarFase(row, ProvaFase.FASE1)" matTooltip="Mover para Primeira Fase">
                <mat-icon>arrow_back</mat-icon>
              </button>
            </div>                
            <div fxFlex fxLayoutAlign="center center" class="distribute-exams">
              {{ tipoProvaStr(row.tipoProva) }}
            </div>        
            <div>
              <button mat-mini-fab color="primary" (click)="atualizarFase(row, ProvaFase.FASE2)" matTooltip="Mover para Segunda Fase">
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>    
          </div>
        </mat-card>
      </div>
    </div>
    
    <div fxFlex="40%" class="fase-quadros">
      <div class="table-title">Segunda Fase</div>
      <div *ngFor="let row of provasSegundaFase; let i = index">
        <mat-card class="exam-card" [ngClass]="{ 'order-alert': row.provaOrdem == null }">          
          <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">            
            <div fxFlex="auto">
              <b>{{ row.provaOrdem }}ª</b>: {{ tipoProvaStr(row.tipoProva) }}
            </div>                    
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
              <span>Peso:</span>
              <input matInput fxFlex="0 1 50px" type="number" min="0" [(ngModel)]="row.provaPeso" 
                     (focus)="valorAnteriorPeso = row.provaPeso"
                     (blur)="atualizarPeso(row, row.provaPeso)"
                     (keyup.enter)="atualizarPeso(row, row.provaPeso)"
                     class="w-50" />
            </div>                    
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="2px">
              <button mat-icon-button (click)="atualizarOrdem(row, (row.provaOrdem ?? 0) - 1)" matTooltip="Subir" [disabled]="i === 0">
                <mat-icon class="small-icon">arrow_upward</mat-icon>
              </button>
              <button mat-icon-button (click)="atualizarOrdem(row, (row.provaOrdem ?? 0) + 1)" matTooltip="Descer" [disabled]="i === provasSegundaFase.length - 1">
                <mat-icon class="small-icon">arrow_downward</mat-icon>
              </button>
              <button mat-icon-button (click)="atualizarFase(row, ProvaFase.FASE1)" matTooltip="Mover para Primeira Fase">
                <mat-icon class="small-icon">arrow_back</mat-icon>
              </button>
              <button mat-icon-button (click)="excluir(row)" matTooltip="Excluir" [disabled]="row.temNotas">
                <mat-icon class="small-icon">close</mat-icon>
              </button>
            </div>
          </div>                  
          <div *ngIf="row.provaOrdem === 1" fxLayout="column" fxLayoutGap="5px">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <span>Início das correções:</span>
              <input matInput type="date"
                class="w-150"
                [value]="row.dataInicio"
                (focus)="valorAnteriorDataInicial = row.dataInicio"
                (change)="atualizarDataInicial(row, $event)" />
            </div>
            <div *ngIf="deveExibirDataInicioDocumentos(row)" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
              <span>Início da visualização dos documentos:</span>
              <input matInput type="date"
                class="w-150"
                [value]="row.dataInicioDocumentos"
                (focus)="valorAnteriorDataInicioDocumentos = row.dataInicioDocumentos"
                (change)="atualizarDataInicioDocumentos(row, $event)" />
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>